"use client";

// import { Icon, ospThemes } from "@ospweb/sdk-ui";
import { cn, getAssetsUrl } from "utils";
import { useCallback, useMemo } from "react";
import { useOspLogin } from "@/src/features/auth/compat/useOspLogin";
import { useSnapshot } from "valtio";
import NextImage from "../NextImage";
// import { MenuSearchModalCreateAble } from "./MenuSearchModal/MenuSearchModal";
import { ProfileButton } from "./ProfileButton";
import { HomeStore, rootStore } from "@store";

import { EDGEN_TO_EXT_LOGIN_KEY } from "@/src/features/login/types";
import { ExtensionMessageType } from "@/src/config";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Menu/LoginInfo";
import { useLoginModalProvider } from "@hooks";

export const LoginInfo = ({
  locale,
  clickEnable = true,
  className,
}: {
  locale?: string;
  clickEnable?: boolean;
  className?: string;
}) => {
  const { open } = useLoginModalProvider();
  const { logout: authLogout } = useOspLogin();
  const loginSnapshot = useSnapshot(rootStore.login);
  const userSnapshot = useSnapshot(rootStore.user);
  const { isOpen } = useSnapshot(HomeStore);

  // 原先这里有一条「Web3 断连则自动登出」的 effect。它的条件是
  // `!isWeb3Connected && isOspLogin`，而 useOspLogin 兼容层把两者都映射成
  // 同一个 isAuthenticated，恒为 false —— 是永远不会触发的死代码，故移除。
  // 若后续真要恢复"会话失效自动登出"，应由 authStore 的 error 状态驱动。

  const logout = useCallback(async () => {
    window?.postMessage(
      {
        key: EDGEN_TO_EXT_LOGIN_KEY,
        payload: {
          type: ExtensionMessageType.LOGOUT_SUCCESS,
          data: null,
        },
      },
      "*",
    );
    await authLogout();
  }, [authLogout]);
  if (loginSnapshot.isFetching && !loginSnapshot.isLoggedIn) {
    return null;
  }
  return (
    <div
      className={cn("relative py-3 px-5 flex justify-center", className, {
        "justify-start": loginSnapshot.isLoggedIn,
        "flex-col gap-3 items-center justify-center": !isOpen,
      })}
    >
      {/* {!isOpen && (
        <div
          data-openreplay-label="Menu · LoginInfo · div"
          onClick={async () => {
            await MenuSearchModalCreateAble({
              type: "normal",
            });
          }}
          className="p-2 w-9 h-9 bg-background_white_overlay10 hover:bg-background_white_overlay20 rounded-full flex items-center justify-center cursor-pointer"
        >
          <Icon
            name="search"
            size={16}
            color={ospThemes.colors.content_primary}
          />
        </div>
      )} */}
      {loginSnapshot.isLoggedIn && (
        <ProfileButton
          avatar={userSnapshot.ownerInfo?.avatar}
          userName={userSnapshot.ownerInfo?.name}
          logout={logout}
          clickEnable={clickEnable}
        />
      )}
      {/* 登录按钮 - 内部判断是否显示 */}
      <LoginSignupButton locale={locale} />
      {!loginSnapshot.isLoggedIn && !isOpen && (
        <NextImage
          data-openreplay-label="Menu · LoginInfo · NextImage"
          src="/assets/images/unlogin.webp"
          alt="unlogin"
          className="w-full w-9 h-9 cursor-pointer"
          onClick={() => {
            open?.();
          }}
        />
      )}
    </div>
  );
};

const LoginSignupButton = ({ locale }: { locale?: string }) => {
  const { open } = useLoginModalProvider();
  const loginSnapshot = useSnapshot(rootStore.login);
  const { isOpen } = useSnapshot(HomeStore);
  const I18n = useMemo(
    () => I18nUtil.createScoped(Translations, locale),
    [locale],
  );
  if (!loginSnapshot.isLoggedIn && isOpen) {
    return (
      <div
        className={cn(
          "relative w-full h-14",
          "before:absolute before:-right-0.5 before:top-0",
          "before:pl-11 before:pt-1 before:pb-3 before:pr-3",
          "before:body_bold_xs before:text-content_inverse_primary",
          "before:[background-image:var(--bg-image)] before:bg-no-repeat before:bg-cover before:bg-right-top",
          "before:content-[attr(data-content)]",
          "before:pointer-events-none",
        )}
        style={{
          "--bg-image": `url(${getAssetsUrl("/assets/images/rectangle-light.svg")})`,
        }}
        data-content={I18n.t("Free Alpha Signals")}
      >
        <button
          aria-label="Login Info"
          data-openreplay-label={`Login Info Button | ${I18n.t("Log in/ Sign up")}`}
          id="btn-login-info"
          className="button secondary_button ring-2 ring-border_brand_solid sm_button button_m bg-background_solid_neutral_tertiary not-loading-and-disabled:hover:bg-background_solid_neutral_tertiary text-content_primary w-full absolute bottom-0 z-1"
          onClick={() => {
            open?.();
          }}
          suppressHydrationWarning
        >
          {I18n.t("Log in/ Sign up")}
        </button>
      </div>
    );
  }
  return null;
};
